import { Constants, Message } from '../../types/default-types'

export interface ConstProps {
  data?: Constants
  loading: boolean
  init: boolean
  error?: Message[]
}

export const FETCH_CONSTANTS_REQUEST = 'FETCH_CONSTANTS_REQUEST'
export const FETCH_CONSTANTS_SUCCESS = 'FETCH_CONSTANTS_SUCCESS'
export const FETCH_CONSTANTS_FAILURE = 'FETCH_CONSTANTS_FAILURE'

interface Request {
  type: typeof FETCH_CONSTANTS_REQUEST
  payload: any
}

interface Success {
  type: typeof FETCH_CONSTANTS_SUCCESS
  payload: any
}

interface Failure {
  type: typeof FETCH_CONSTANTS_FAILURE
  payload: any
}

export type CONST = Request | Success | Failure
